import React, { memo, ReactElement } from "react";
import { DeliveryAddressViewV4 } from "./v4";
interface DeliveryAddressViewProps {
    pickupName: string;
    pickupSubtext: string;
    PickupIcon: React.FunctionComponent;
    LineIcon: React.FunctionComponent;
    deliveryAddress: string;
    deliveryAnnotation: string;
    DeliveryIcon: React.FunctionComponent;
    couponBannerVisible: boolean;
}

function DeliveryAddressView(props: DeliveryAddressViewProps): ReactElement {
    return <DeliveryAddressViewV4 {...props} />;
}

export default memo(DeliveryAddressView);
